/* eslint-disable react/react-in-jsx-scope */
import { DropDownProps, TableDropDown } from './types';
import './styles.scss';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
// eslint-disable-next-line import/named
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SVGIconClose } from 'assets/svg';
import { MenuList, TextField } from '@mui/material';
import { MyTextInput } from 'components/Input';
import { TYPE_INPUT } from 'constants/AppEnums';
import IcSearch from '../../assets/svg/ic_search.svg';
import { TextFieldActions } from 'components/Input/types';
import React from 'react';


const MenuListComponent = forwardRef(({ dataFilter, onPress, setValue, handleClose }: { dataFilter: any, onPress: any, setValue: any, handleClose: any }, ref) => {
    const [data, setData] = useState<any>(dataFilter || []);

    const filterData = (_data) => {
        setData(_data);
    };

    useImperativeHandle(ref, () => ({
        filterData
    }));

    return (
        <div style={{ maxHeight: "220px", overflowY: "auto" }}>
            <MenuList>
                {data.length > 0 ? (
                    data.map((item, index) => {
                        const onChoose = () => {
                            onPress?.(item);
                            setValue(item?.value);
                            handleClose();
                        };
                        return (
                            <MenuItem onClick={onChoose} key={index}>
                                {item.value}
                            </MenuItem>
                        );
                    })
                ) : (
                    <MenuItem disabled>Không có kết quả</MenuItem>
                )}
            </MenuList>
        </div>
    );
});

function DropDownComponent({
    label,
    iconLeft,
    iconRight,
    styleIconRight,
    styleIconLeft,
    styleLabel,
    stylesContainer,
    onPress,
    widthMenu,
    data,
    stylesDrops,
    defaultValue,
    isClose,
    isSearch
}: DropDownProps, ref) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [open, setOpen] = useState<boolean>(false);
    const [value, setValue] = useState<string>(defaultValue);
    const [err, setErrDropDown] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('');
    const refInput = useRef<TextFieldActions>(null);
    // const [dataFilter, setDataFilter] = useState<TableDropDown[]>(data || []);
    const refMenuList = useRef<any>(null);
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setOpen(true);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };

    const setErr = (isErr: boolean) => {
        setErrDropDown(isErr);
    };

    const setValueDrop = (_value) => {
        setValue(_value);
    };

    const getValue = () => {
        return value;
    };

    useImperativeHandle(ref, () => ({
        setErr,
        setValueDrop,
        getValue
    }));

    const StyledMenu = styled((props: MenuProps) => (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            {...props}
        />
    ))(({ theme }) => ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 150,
            width: widthMenu,
            maxHeight: '60vh',
            color:
                theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
            boxShadow:
                'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
                padding: '4px 0'
            },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5)
                },
                '&:active': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        theme.palette.action.selectedOpacity,
                    )
                }
            }
        }
    }));

    const onClear = () => {
        setValue('');
        onPress?.({ id: '', value: '' });
        setAnchorEl(null);
    };

    const dataFilter = useMemo(() => {
        if (!search) return data;
        return data.filter(item => item.value?.toLowerCase().includes(search.toLowerCase()));
    }, [search, data]);

    const renderView = useMemo(() => {
        return (
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button'
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {isSearch ? <div style={{ padding: '16px 16px 0px 16px' }}>
                    <MyTextInput
                        ref={refInput}
                        rightIcon={IcSearch}
                        type={TYPE_INPUT.TEXT}
                        containerInput={'input-drops border'}
                        inputStyle={'input-style'}
                        placeHolder={'Search items'}
                        value={search}
                        onChangeText={(text) => {
                            setSearch(text);
                            const _data = data.filter(item => item.value?.toLowerCase().includes(text.toLowerCase()));
                            refMenuList?.current?.filterData(_data);
                        }}
                    />
                </div> : null}
                <MenuListComponent ref={refMenuList} dataFilter={dataFilter} onPress={onPress} setValue={setValue} handleClose={handleClose} />
            </StyledMenu>
        );
    }, [open]);

    return (
        <div className={`${stylesContainer} drop-down`}>
            <div className={`${stylesDrops} drops-main`} >
                <div onClick={handleClick} style={{ width: 'calc(100% - 35px)', flexDirection: 'row', display: 'flex', minWidth: 40 }}>
                    {iconLeft && <div className={`${styleIconLeft}`}  >{iconLeft}</div>}
                    <div className={`${styleLabel} center`} style={{ color: err ? 'red' : '' }}>{value || defaultValue || label}</div>
                </div>
                {iconRight && <>
                    {((value || defaultValue) && isClose) ? <div className={`${styleIconRight}`} style={{ width: 20, height: 20, justifyContent: 'center', alignItems: 'center', display: 'flex' }} onClick={onClear}>
                        <SVGIconClose />
                    </div> : <div className={`${styleIconRight}`} onClick={handleClick}>{iconRight}</div>}
                </>}
            </div>
            {renderView}
        </div>
    );
}

export default forwardRef(DropDownComponent);
